import { includes, union } from 'ramda';
import { ProjectModule } from 'providers/api';

export const PC_PROJECT_MODULES: ProjectModule[] = [ProjectModule.StopeFill, ProjectModule.Flushing];

export const isPcProjectModule = (module: ProjectModule): boolean => includes(module, PC_PROJECT_MODULES);

/**
 * P&C projects always have the P&C modules on, regardless of what is stored — they are created with no modules
 * and P&C users cannot see the module checkboxes, so the stored list alone would hide these features from them.
 */
export const getEffectiveModules = (enabledModules: ProjectModule[], isPatersonAndCookeProject?: boolean): ProjectModule[] => (
  isPatersonAndCookeProject ? union(enabledModules, PC_PROJECT_MODULES) : enabledModules
);
